import { render } from "./role-areas-popup.vue?vue&type=template&id=5aea141c"
import script from "./role-areas-popup.vue?vue&type=script&setup=true&lang=js"
export * from "./role-areas-popup.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/administration/users/role-areas-popup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5aea141c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5aea141c', __exports__)) {
    api.reload('5aea141c', __exports__)
  }
  
  module.hot.accept("./role-areas-popup.vue?vue&type=template&id=5aea141c", () => {
    api.rerender('5aea141c', render)
  })

}


export default __exports__